import React from "react";
import AudioIcon from "../assets/fileextension/audio.svg";
import DefaultIcon from "../assets/fileextension/blank.svg";
import CsvIcon from "../assets/fileextension/csv.svg";
import ExcelIcon from "../assets/fileextension/excel.svg";
import GdocsIcon from "../assets/fileextension/gdocs.svg";
import ImageIcon from "../assets/fileextension/image.svg";
import PDFIcon from "../assets/fileextension/pdf.svg";
import PPTIcon from "../assets/fileextension/ppt.svg";
import PsdIcon from "../assets/fileextension/psd.svg";
import SqlIcon from "../assets/fileextension/sql.svg";
import TxtIcon from "../assets/fileextension/txt.svg";
import VideoIcon from "../assets/fileextension/video.svg";
import WordIcon from "../assets/fileextension/word.svg";
import ZipIcon from "../assets/fileextension/zip.svg";

// 🔥 Optional: Assign a real Publisher icon if you have one.
const PublisherIcon = DefaultIcon; // fallback if you don't have a separate Publisher icon

export const getFileIcon = (file_extension) => {
  const style = { width: 48, height: 48, marginRight: 12 };

  switch (file_extension?.toLowerCase()) {
    case "xlsx":
    case "xls":
    case "xlx":
      return React.createElement("img", {
        alt: "Excel file",
        style,
        src: ExcelIcon,
        loading: "lazy",
      });
    case "docx":
    case "doc":
      return React.createElement("img", {
        alt: "Word file",
        style,
        src: WordIcon,
        loading: "lazy",
      });
    case "ppt":
    case "pptx":
      return React.createElement("img", {
        alt: "PowerPoint file",
        style,
        src: PPTIcon,
        loading: "lazy",
      });
    case "pub":
      return React.createElement("img", {
        alt: "Publisher file",
        style,
        src: PublisherIcon,
        loading: "lazy",
      });
    case "pdf":
      return React.createElement("img", {
        alt: "PDF file",
        style,
        src: PDFIcon,
        loading: "lazy",
      });
    case "zip":
    case "rar":
      return React.createElement("img", {
        alt: "Compressed file",
        style,
        src: ZipIcon,
        loading: "lazy",
      });
    case "csv":
      return React.createElement("img", {
        alt: "CSV file",
        style,
        src: CsvIcon,
        loading: "lazy",
      });
    case "txt":
      return React.createElement("img", {
        alt: "Text file",
        style,
        src: TxtIcon,
        loading: "lazy",
      });
    case "psd":
      return React.createElement("img", {
        alt: "Photoshop file",
        style,
        src: PsdIcon,
        loading: "lazy",
      });
    case "webp":
      return React.createElement("img", {
        alt: "WebP file",
        style,
        src: GdocsIcon,
        loading: "lazy",
      });
    case "sql":
      return React.createElement("img", {
        alt: "SQL file",
        style,
        src: SqlIcon,
        loading: "lazy",
      });
    // case "svg":
    //   return React.createElement("img", {
    //     alt: "SVG file",
    //     style,
    //     src: PublisherIcon,
    //     loading: "lazy",
    //   });
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "bmp":
    case "ico":
    case "svg":
      return React.createElement("img", {
        alt: "PNG file",
        style,
        src: ImageIcon,
        loading: "lazy",
      });
    case "mp4":
    case "avi":
    case "mkv":
    case "mov":
    case "mpeg":
    case "wmv":
      return React.createElement("img", {
        alt: "Video file",
        style,
        src: VideoIcon,
        loading: "lazy",
      });
    case "mp3":
      return React.createElement("img", {
        alt: "Video file",
        style,
        src: AudioIcon,
        loading: "lazy",
      });
    default:
      return React.createElement("img", {
        alt: "Default file",
        style,
        src: DefaultIcon,
        loading: "lazy",
      });
  }
};

export const getFileExtension = (filename) => {
  const lastDotIndex = filename.lastIndexOf(".");
  return lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : "";
};

export const truncateFileName = (name, maxLength = 40) => {
  if (name.length <= maxLength) return name;

  const dotIndex = name.lastIndexOf(".");
  const extension = name.slice(dotIndex);
  const baseName = name.slice(0, dotIndex);
  const visibleLength = maxLength - extension.length - 3; // -3 for '...'
  return `${baseName.slice(0, visibleLength)}...${extension}`;
};

export const formatFileSize = (sizeInBytes) => {
  if (sizeInBytes >= 1_073_741_824) { // 1024^3
    return (sizeInBytes / 1_073_741_824).toFixed(2) + " GiB"; // GiB (Gibibytes)
  } else if (sizeInBytes >= 1_048_576) { // 1024^2
    return (sizeInBytes / 1_048_576).toFixed(2) + " MiB"; // MiB (Mebibytes)
  } else if (sizeInBytes >= 1_024) { // 1024
    return (sizeInBytes / 1_024).toFixed(2) + " KiB"; // KiB (Kibibytes)
  } else {
    return sizeInBytes + " B"; // Bytes
  }
};